<button class="btn btn_primary btn_sm btn_icon" svgIcon [icon]="'plus'" (click)="createSuperAdmin()">
  Create SuperAdmin
</button>

<button class="btn btn_primary btn_sm btn_icon" svgIcon [icon]="'delete-white'" (click)="deleteAccount()">
  Delete User
</button>
<br>
<hr>
<button class="btn btn_icon btn_primary trigger-partner-sync-btn" (click)="triggerPartnerSync()">Trigger Partner
  Sync</button>
<button class="btn btn_icon btn_primary trigger-partner-sync-btn" (click)="triggerSyncProductConfigurationMap()">Trigger
  Sync EANs/Article Numbers</button>
<hr>
<h3>Usage Report</h3>
<div class="reporting-section">
  <span>Select Date Interval:</span>

  <app-input-datepicker [mainForm]="reportingForm" [controlName]="'date'" [placeholder]="'From - To'"
    [config]="{ rangeInputFormat: 'DD.MM.YYYY', showWeekNumbers: false, useUtc: true, adaptivePosition: true }">
  </app-input-datepicker>

  <button class="btn btn_primary btn_sm" (click)="createReport()" [disabled]="isGeneratingReport">Generate</button>
  <div *ngIf="isGeneratingReport" class="tiny-spinner"></div>
</div>
<div *ngFor="let alert of alerts">
  <alert [type]="alert.type" [dismissOnTimeout]="alert.timeout" (onClosed)="onClosed(alert)">{{ alert.msg }}</alert>
</div>